.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 300px);
    padding: 40px 20px;
    text-align: center;
    width: 100%;
}

.iconContainer {
    width: 80px;
    height: 120px;
    border-radius: 40px;
    background: #FEF3C7;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;

    .searchIcon {
        font-size: 32px;
        color: #D69E2E;
    }
}

.title {
    font-size: 20px;
    font-weight: 600;
    color: #102442;
    margin-bottom: 8px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
}

.message {
    font-size: 16px;
    color: #102442;
    line-height: 1.5;
    max-width: 500px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    white-space: nowrap;
    
    @media (max-width: 768px) {
        white-space: normal;
        max-width: 400px;
    }
} 